import { Component, Inject } from '@angular/core';
import { environment } from '@env/environment';
import { Restangular } from 'ngx-restangular';
import { AdminService } from './admin.service';
import { CoreService } from '../core/core.service';
// import { Router } from '@angular/router';

@Component({
  selector: 'cp-comment',
  templateUrl: './comments.component.html',
})

export class CommentComponent {
  filter: string;
  itemsPerPage: number;
  totalItems: number;
  currentPage: number;
  comments: any[];
  baseUrl: string = environment.production
    ? environment.ONLINE_BASE_URL :
    environment.LOCAL_BASE_URL;
  constructor(private api: AdminService, @Inject(Restangular) public Restangular, private coreService: CoreService) {
    this.filter = '&status=';
    this.itemsPerPage = 10;
    this.totalItems = 0;
    this.currentPage = 1;
    this.comments = [];
    this.getCommentsFilter('unread,read');
  }

  getCommentsFilter(filter: any) {
    this.filter = this.filter + filter;
    this.getComments();
  }

  getComments() {

    let j = this.itemsPerPage * this.currentPage - this.itemsPerPage;
    this.api.getComments(this.currentPage, this.filter).subscribe((resp: any) => {
      this.comments = resp.data;
      for (let i = 0; i < this.comments.length; i++) {
        this.comments[i].no = j + 1;
        j++;
      }
      this.totalItems = resp.meta.pagination.total;
      this.itemsPerPage = resp.meta.pagination.per_page;
    });
  }

  pageChanged(event: any) {
    event = event;
    this.currentPage = this.currentPage;
    this.getComments();
  }

  changeStatus(id: any, status: any) {
    this.api.changeCommentStatus(id, status).subscribe((res: any) => {
      //this.coreService.addToast('Success', res.data.title);
      this.getComments();
    }, (err) => {
      //this.coreService.addToast('Error', err.statusText);
    });
  }

}
